import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-location-lookup',
  templateUrl: './micro-location-lookup.component.html'
})
export class MicroLocationLookupComponent  {

  @Input()
  locationId:any;

  @Input()
  link:boolean = true;
}
